<template>
  <div class="live-videos-chapter">
    <Row>
      <Col :xs="24"
           :sm="22">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入关键词查找..."></Input>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.status"
                  clearable
                  filterable
                  placeholder="状态...">
            <Option value="0"
                    key="0">禁用</Option>
            <Option value="1"
                    key="1">正常</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
      </Form>
      </Col>
      <Col :xs="24"
           :sm="2">
      <Button @click="showModel()"
              type="success"
              class="f-l">添加</Button>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer title="编辑"
            v-model="showModalStatus"
            width="50"
            scrollable
            :mask-closable="false"
            :loading="loading">
      <Form :model="editInfo"
            ref="editInfoValidate"
            :rules="editInfoValidate"
            action="javascript:void(0)">
        <List>
          <ListItem>
            <FormItem label="标题"
                      prop="title">
              <Input v-model="editInfo.title"
                     placeholder="标题"></Input>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="试看分钟"
                      prop="times">
              <Input v-model="editInfo.times"
                     placeholder="试看分钟"></Input>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="描述"
                      prop="describe">
              <Input type="textarea"
                     v-model="editInfo.describe"
                     placeholder="描述..."
                     :autosize="{minRows:4,maxRows:8}"
                     style="min-width:400px;"></Input>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="缩略图"
                      prop="thumb">
              <upload-thumb v-model="editInfo.thumb"
                            ref="uploadthumb"
                            :defaultList="thumblist"
                            tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png、gif,<br>建议图片尺寸:686*284,大小不超过2M</span>"></upload-thumb>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="上传视频"
                      prop="url">
              <upload-video ref="uploadvideo"
                            v-model="editInfo.url"
                            :defaultList="videolist"></upload-video>
            </FormItem>
          </ListItem>
          <ListItem>
            <FormItem label="三方视频">
              <!--<tinymce-editor ref="editContent"></tinymce-editor>-->
              <Input type="textarea"
                     v-model="editInfo.thurl"
                     placeholder="三方视频..."
                     :autosize="{minRows:4,maxRows:8}"
                     style="min-width:400px;"></Input>
            </FormItem>
          </ListItem>

          <ListItem>
            <FormItem label="排序"
                      prop="sort">
              <Input v-model="editInfo.sort"
                     placeholder="排序"></Input>
            </FormItem>
          </ListItem>
          <ListItem>
            <div class="demo-drawer-footer">
              <Button type="primary"
                      @click="editLiveRoom('editInfoValidate')">提交</Button>
            </div>
          </ListItem>
        </List>
      </Form>
    </Drawer>

    <!-- 图片查看 end -->
    <Drawer :title="commentDetail.title"
            :closable="true"
            scrollable
            width="50"
            :mask-closable="false"
            v-model="commentDrawerStatus">
      <Table :columns="commentColumns"
             :data="commentDetail.list"
             no-data-text="没有评论"
             size="small"></Table>
      <!-- <p v-for="(item,key) in commentDetail.list" :key="key">{{ item.content }}{{ item.created_at }}</p> -->
    </Drawer>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import UploadVideo from "../common/videochapter";
// import TinymceEditor from '../common/tinymce'
export default {
  name: "live-videos-chapter",
  data () {
    const validateThumb = (rule, value, callback) => {
      if (this.$refs["uploadthumb"].uploadList.length > 0) {
        callback();
      } else {
        callback(new Error("请上传封面图"));
      }
    };
    // const validateVideo = (rule, value, callback) => {
    //     if (this.$refs["uploadvideo"].videoList.length > 0) {
    //         this.editInfo.url = this.$refs["uploadvideo"].videoList[0].url;
    //         callback();
    //     } else {
    //         callback(new Error('请上传视频'));
    //     }
    // };
    return {
      commentDrawerStatus: false,
      loading: true,
      dataloading: true,
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: "",
      formItem: {
        key: "",
        status: "",
        livestatus: "",
        typeid: ""
      },
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "排序",
          width: 70,
          key: "name",
          render: (h, params) => {
            return h("div", [
              h(
                "Input",
                {
                  props: {
                    value: params.row.sort
                  },
                  on: {
                    "on-enter": value => {
                      this.editSort(params.row.id, value.target.value);
                    }
                  }
                },
                "排序"
              )
            ]);
          }
        },
        {
          title: "视频名称",
          key: "title",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.livevideo != null ? params.row.livevideo.title : ""
              )
            ]);
          }
        },
        {
          title: "章节标题",
          key: "title",
          minWidth: 150
        },
        {
          title: "试看时长（分）",
          key: "times",
          width: 150
        },
        {
          title: "封面图",
          key: "headimgurl",
          width: 90,
          render: (h, params) => {
            return h("div", [
              h(
                "Avatar",
                {
                  props: {
                    src: this.$publicData.ossUrl + params.row.thumb,
                    shape: "square",
                    size: "large"
                  }
                },
                ""
              )
            ]);
          }
        },
        {
          title: "视频地址",
          key: "url",
          width: 300
        },
        {
          title: "视频三方地址",
          key: "thurl",
          width: 300
        },
        {
          title: "描述",
          key: "describe",
          width: 400
        },
        {
          title: "状态",
          width: 90,
          key: "status",
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  props: {
                    value: params.row.status == 1 ? true : false //控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": value => {
                      this.changeStatus(params.row.id, value);
                    }
                  }
                },
                "开关"
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.index, params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              // h(
              //   "Button",
              //   {
              //     props: {
              //       type: "info",
              //       loading: this.commentBtnLoading,
              //       disabled: params.row.comment.length == 0 ? true : false
              //     },
              //     on: {
              //       click: () => {
              //         this.showComment(params.row.id);
              //       }
              //     }
              //   },
              //   "查看评论"
              // ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.index, params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      editInfo: {
        title: "",
        type_id: 0,
        describe: "",
        uuid: "",
        thumb: "",
        is_hot: "",
        pos_flag: 0,
        sort: 0,
        times: 0
      },
      editInfoValidate: {
        title: [{ required: true, message: "标题", trigger: "blur" }],
        describe: [{ required: true, message: "描述", trigger: "blur" }],
        // url: [
        //     {required: true, validator: validateVideo, trigger: 'change'}
        // ],
        thumb: [{ required: true, validator: validateThumb, trigger: "change" }]
      },
      thumblist: [],
      videolist: [],
      isClear: false,
      params: {
        key: "",
        status: ""
      },
      video_id: 0,
      commentDetail: {
        title: "评论详情",
        list: []
      },
      commentColumns: [
        // 评论详情表格表头
        {
          title: "评论时间",
          key: "created_at",
          width: 170
        },
        {
          title: "内容",
          key: "content",
          minWidth: 300
        },
        {
          title: "评论人",
          key: "xx_staff_name",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.userdata != null ? params.row.userdata.nickname : ""
              )
            ]);
          }
        }
      ],
      commentBtnLoading: false
    };
  },
  // 组件
  components: {
    UploadThumb,
    UploadVideo
    // TinymceEditor
  },
  created: function () {
    this.video_id = this.$route.params.id;
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function () {
      this.$api.liveVideosChapter
        .list({
          page: this.pages.page,
          size: this.pages.size,
          video_id: this.video_id
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
    },
    // 查看评论
    showComment: function (id) {
      this.commentBtnLoading = true;
      this.commentDetail.list = [];
      this.$api.liveVideosChapter
        .comment({
          live_videos_chapter_id: id,
          size: 9999
        })
        .then(res => {
          console.log(res);
          if (res.code == 200) {
            this.commentDetail.title = "评论";
            if (res.result.list != null) {
              this.commentDetail.list = res.result.list;
            }
            this.commentDrawerStatus = true;
          }
          this.commentBtnLoading = false;
        });
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.liveVideosChapter
        .status({ id: index, status: value })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
          }
        });
    },
    showModel () {
      this.editInfo = {
        title: "",
        type_id: 0,
        describe: "",
        uuid: "",
        thumb: "",
        is_hot: "",
        pos_flag: 0,
        sort: 0
      };
      this.thumblist = [];
      this.videolist = [];
      this.showModalStatus = !this.showModalStatus;
    },
    // 详情
    detail (index, id) {
      this.title = "编辑";
      this.editInfo = {
        title: "",
        type_id: 0,
        describe: "",
        uuid: "",
        thumb: "",
        is_hot: "",
        pos_flag: 0,
        sort: 0,
        times: 0
      };
      this.thumblist = [];
      this.videolist = [];
      this.$api.liveVideosChapter.detail({ id: id }).then(res => {
        this.showModalStatus = !this.showModalStatus;
        this.editInfo = res.result;
        //处理thumb
        if (this.editInfo.thumb != null && this.editInfo.thumb != "") {
          this.thumblist.push({
            name: this.editInfo.thumb,
            url: this.editInfo.thumb,
            status: "finished"
          });
        }
        if (this.editInfo.url != null && this.editInfo.url != "") {
          this.videolist.push({
            name: this.editInfo.url,
            url: this.editInfo.url,
            fullurl: this.$publicData.ossUrl + this.editInfo.url,
            status: "finished"
          });
          this.$refs["uploadvideo"].uploadStatus = false;
        }

        // 更新编辑器
        // this.$refs['editContent'].tinymce_value =  this.editInfo.thurl
      });
    },
    // 修改排序
    editSort: function (index, value) {
      this.$api.liveVideosChapter.sort({ id: index, sort: value }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.getTableList();
        }
      });
    },
    // 删除
    remove: function (index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.liveVideosChapter.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.renderTable(1);
              // this.tablelist.splice(index, 1);
            }
          });
        }
      });
    },

    editLiveRoom (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.$refs["uploadthumb"].uploadList.length > 0) {
            this.editInfo.thumb = this.$refs["uploadthumb"].uploadList[0].url;
          } else {
            this.editInfo.thumb = null;
          }
          console.log(this.$refs["uploadvideo"].videoList);
          if (this.$refs["uploadvideo"].videoList.length > 0) {
            this.editInfo.url = this.$refs["uploadvideo"].videoList[0].url;
          } else {
            this.editInfo.url = null;
          }
          this.editInfo.video_id = this.video_id;
          // 富文本
          // this.editInfo.thurl = this.$refs['editContent'].tinymce_value
          if (this.editInfo.id == null || this.editInfo.id == 0) {
            this.$api.liveVideosChapter.create(this.editInfo).then(res => {
              if (res.code == 200) {
                this.renderTable(1);
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          } else {
            this.$api.liveVideosChapter.edit(this.editInfo).then(res => {
              if (res.code == 200) {
                this.renderTable(1);
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          }
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        status: this.formItem.status,
        video_id: this.video_id
      };
      this.$api.liveVideosChapter.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.role_ids = res.result.role_ids;
          this.pages.total = res.result.total;
        }
      });
      return;
    }
  }
};
</script>

<style scoped>
</style>